import { useQuery } from "@tanstack/react-query";
import categoryApi from "$api/categoryApi";
import { CacheInvalidationAction } from "$utils/cache";
import { formatCategory } from "$utils/categoryUtils";
import useAuth from "./useAuth";
import { unsensitiveIsSameString } from "$utils/utils";

export const REFERENCING_CATEGORY_NAME = "Référencement";

export const isReferencingCategoryName = (categoryName: string) => {
  if (!categoryName) return false;
  return (
    categoryName
      .toUpperCase()
      .localeCompare(REFERENCING_CATEGORY_NAME.toUpperCase(), "fr", {
        sensitivity: "base",
      }) === 0
  );
};

export const useCategoriesQuery = (companyId: string) => {
  const { token: ReduxToken } = useAuth();
  const token = localStorage.getItem("access_token") || ReduxToken || "";

  return useQuery({
    queryKey: [CacheInvalidationAction.GET_CATEGORIES, companyId],

    queryFn: async () => {
      const response = await categoryApi.getCategory(token, companyId);
      const categories = (response as any)?.data?.categories || [];
      const { groupedCategories, orderedCategories } =
        formatCategory(categories);
      return { categories, groupedCategories, orderedCategories };
    },

    enabled: !!companyId,
    staleTime: 5 * 60 * 1000,
  });
};

export const useReferencingCategoryQuery = (companyId: string) => {
  const { data } = useCategoriesQuery(companyId);

  const referencingCategory = data?.orderedCategories?.find((c: any) =>
    unsensitiveIsSameString(REFERENCING_CATEGORY_NAME, c.title)
  );

  return { referencingCategory };
};
